<template>
<!-- 登入 -->

    <div class="login">
        <div class="loginDiv">
            <div class="loginTitle">登入</div>
            <div class="wrap-login100">
                <el-form :model="loginObj" :rules="rules" ref="loginObj" class="form">
                    <el-form-item label="用户名：" class="labelWidth" prop="username">
                        <el-input class="input100" type="text" v-model="loginObj.username" @keyup.enter.native="submit('loginObj')" name="username" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="密码：" class="labelWidth" prop="password">
                        <el-input class="input100" type="password" v-model="loginObj.password" @keyup.enter.native="submit('loginObj')" name="pass" placeholder="请输入用户名"></el-input>
                    </el-form-item>

                    <div class="flex-sb-m w-full p-b-30">
                        <div class="txt2">
                            <!-- <a href="javascript:" class="txt1">忘记密码？</a> -->
                            
                        </div>
                    </div>
                    <div class="container-login100-form-btn">
                        <el-button class="login100-form-btn" type="primary"  @click="submit('loginObj')">登 录</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import {login} from '@/service'
export default {
    name: 'YinshiOffcialwebsiteLogin',
    data() {
        return {
            loginObj:{
                username:'',
                password:''
            },
            // 验证
            rules:{
                username:[{ required: true, message: '请输入您的姓名', trigger: 'blur' }],
                password: [{ required: true, message: '请输入您的密码', trigger: 'blur' }],
            }
        };
    },

    mounted() {
    },

    methods: {
        // 提交登入
        submit(loginObj){
            this.$refs[loginObj].validate(async (valid) => {
                if (valid) {
                    let res = await login(this.loginObj);
                    if(res.code == 200){
                        // 登入的时候保存token
                        if(res.data){
                            localStorage.setItem("token",res.data);
                        }
                        this.$message({ message: '登录成功！', type: 'success' });
                        this.$router.push('/admin')
                    }else{
                        this.$message({message:'登录失败！',type: 'error'});
                    }
                } else {
                    return false;
                }
            });
        },
    },    
    created(){
    }
};
</script>
<style lang="scss">
    .login{
        .el-input__inner{
            width: 100%;
            margin-left: -5px;
            padding-left: 5px;
            width: 300px;
        }
        .labelWidth{
            label{
                width: 85px;
            }
            display: flex;
        }
    }
</style>
<style lang="scss" scoped>
.login{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    background: #ebeeef;
}
.loginDiv{
    margin-top: -200px;
}
// title
.loginTitle{
    font-size: 36px;
    margin-bottom:80px;
    text-align: center;
}
.login100-form-title{
    background: red;
    background: url(images/bg-01.jpg);
    background-size: 100% 100%;
    width: 679px;
    height: 175px;;
}
.txt2{
    text-align: right;
    width: 100%;
    padding-right: 20px;
}
.form{
    // margin-top: -80px;
}
.container-login100-form-btn{
    margin-top: 40px;
    text-align: center;
}
</style>